
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetokonkandarshancabs() {



    const cardData =
    {
        keyword: 'Pune to Konkan Darshan Cabs',
        heading: 'Platinum24 Cabs: Pune to Konkan Darshan Cabs',
        headingDescription: ' Platinum24 Cabs offers comfortable Pune to Konkan Darshan Cabs, ideal for exploring the stunning beaches, historic forts, and temples of the Konkan coastline. Our fleet includes hatchbacks, sedans, SUVs, and luxury cars designed for long drives, ensuring a smooth ride across winding coastal routes. With professional chauffeurs, on-time pickups, and affordable packages, we make your Konkan tour stress-free and enjoyable. Whether you’re planning a family holiday to Ganpatipule, a spiritual visit to Sindhudurg, or a multi-day coastal tour, Platinum24 Cabs guarantees safe, convenient, and memorable travel from Pune to Konkan.',

        top: 'Top Places to Visit in Konkan with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Ganpatipule Beach & Temple",
    "description": "Ganpatipule is a serene beach town famous for its pristine shores and the 400-year-old Swayambhu Ganpati Temple. Pilgrims visit the naturally formed idol of Lord Ganesha, believed to be self-manifested. The golden sands and turquoise waters attract tourists seeking peace and leisure. Water sports like jet skiing and banana rides add adventure. The town offers delicious Konkani cuisine and homestays. Ganpatipule is Konkan’s blend of spirituality and seaside charm."
  },
  {
    "title": "Sindhudurg Fort",
    "description": "Sindhudurg Fort, built by Chhatrapati Shivaji Maharaj in the 17th century, stands proudly on an island in the Arabian Sea. Known for its massive walls and hidden pathways, it narrates tales of Maratha naval power. The fort houses temples dedicated to Shivaji and local deities. Tourists enjoy ferry rides to reach the fort and explore its history. Scenic sea views make it a photographer’s delight. Sindhudurg is Konkan’s proud maritime heritage."
  },
  {
    "title": "Tarkarli Beach",
    "description": "Tarkarli Beach is a paradise for water sports and scuba diving in Maharashtra. Its clear waters allow sightings of corals and colorful marine life. Tourists enjoy snorkeling, parasailing, and dolphin-spotting rides. Houseboats and beach resorts make it an ideal holiday spot. The golden sands and palm-fringed coastline offer perfect relaxation. Tarkarli is Konkan’s adventure and leisure destination."
  },
  {
    "title": "Alibaug",
    "description": "Alibaug, located close to Mumbai and Pune, is known as the ‘Goa of Maharashtra.’ It boasts clean beaches like Alibaug, Nagaon, and Kashid. Tourists enjoy water sports, forts like Kolaba, and beach resorts. Fresh seafood, coconut plantations, and homestays add to the experience. Weekend travelers find it easily accessible. Alibaug is Konkan’s gateway to sun, sand, and culture."
  },
  {
    "title": "Dapoli",
    "description": "Dapoli is a coastal town surrounded by coconut groves and pristine beaches like Murud and Ladghar. Known as ‘Mini Mahabaleshwar,’ it offers cool weather along with seaside charm. Dolphin-watching rides are a highlight here. Ancient temples and forts add cultural value. Tourists enjoy local Konkani food, especially seafood. Dapoli is Konkan’s perfect family-friendly beach destination."
  },
  {
    "title": "Ratnagiri",
    "description": "Ratnagiri is a historic port city famous for its Alphonso mangoes and cultural heritage. Key attractions include Ratnadurg Fort, Thibaw Palace, and Mandavi Beach. The town also has temples, museums, and scenic viewpoints. Its coastal charm blends history with relaxation. Ratnagiri’s seafood delicacies attract foodies. It is Konkan’s cultural and culinary capital."
  },
  {
    "title": "Velas Turtle Festival",
    "description": "Velas, a small village in Konkan, is famous for its annual Turtle Festival. Olive Ridley turtle hatchlings are released into the sea, attracting eco-tourists from across India. The event promotes wildlife conservation and community tourism. Homestays offer authentic Konkani hospitality. Tourists also enjoy nearby beaches and temples. Velas is Konkan’s unique eco-tourism and cultural event."
  },
  {
    "title": "Harihareshwar",
    "description": "Harihareshwar, often called the ‘Dakshin Kashi,’ is a coastal town with a revered Shiva temple. Surrounded by hills and sea on three sides, it offers spiritual and scenic charm. The rocky coastline and pristine beaches are perfect for quiet holidays. Pilgrims combine darshan with walks along the Harihareshwar beach. The nearby Diveagar and Shrivardhan beaches make for a perfect circuit. Harihareshwar is Konkan’s spiritual and seaside jewel."
  },
  {
    "title": "Diveagar Beach",
    "description": "Diveagar Beach is known for its soft sands, coconut groves, and peaceful vibes. The village was once home to a golden Ganesh idol, making it a spiritual site too. Tourists enjoy water sports, horse rides, and camel rides along the beach. Homestays and resorts add comfort to the trip. Fresh seafood completes the coastal experience. Diveagar is Konkan’s hidden gem of calm and beauty."
  },
  {
    "title": "Jaigad Fort & Lighthouse",
    "description": "Jaigad Fort, perched on a cliff near Ratnagiri, overlooks the Arabian Sea and Jaigad Creek. Built in the 16th century, it played a vital role in Maratha naval defense. The nearby Jaigad Lighthouse offers panoramic sea views. Tourists explore the fort’s bastions, wells, and temples. It is less crowded, making it peaceful for history lovers. Jaigad Fort is Konkan’s scenic heritage watchtower."
  }
],



   "services": [
    {
      "name": "Pune to Konkan Darshan Taxi Services",
      "description": "Comprehensive taxi services from Pune to Konkan Darshan destinations, offering reliable, comfortable rides with experienced drivers. Perfect for exploring the scenic Konkan coast with ease and convenience."
    },
    {
      "name": "Pune to Konkan Darshan Cab Booking",
      "description": "Seamless online cab booking for Pune to Konkan Darshan trips, with instant confirmation and flexible payment options. Tailored to meet your travel needs whether it’s a solo trip or a group tour."
    },
    {
      "name": "Pune to Konkan Darshan Car Rental",
      "description": "Wide range of car rental options for Pune to Konkan Darshan, including economy to luxury vehicles. Choose self-drive or chauffeur-driven services for a personalized travel experience."
    },
    {
      "name": "Pune to Konkan Darshan Chauffeur-Driven Cabs",
      "description": "Premium chauffeur-driven cab services from Pune to Konkan Darshan, ensuring a relaxing journey with professional drivers who know the best routes and local insights."
    },
    {
      "name": "Pune to Konkan Darshan One-Way Taxi",
      "description": "Flexible one-way taxi services from Pune to Konkan Darshan, ideal for travelers seeking point-to-point transportation without round-trip commitments."
    },
    {
      "name": "Pune to Konkan Darshan Round Trip Cabs",
      "description": "Convenient round trip cab services for Pune to Konkan Darshan, perfect for leisure travelers who want a complete sightseeing experience with hassle-free returns."
    },
    {
      "name": "Pune to Konkan Darshan Luxury Taxi",
      "description": "Travel in style with luxury taxi options from Pune to Konkan Darshan, featuring premium vehicles equipped with all modern comforts for an elevated travel experience."
    },
    {
      "name": "Pune to Konkan Darshan Travel Packages",
      "description": "All-inclusive travel packages covering Pune to Konkan Darshan with transportation, sightseeing, and driver allowances included, providing a comprehensive and convenient holiday solution."
    },
    {
      "name": "Pune to Konkan Darshan Private Car Hire",
      "description": "Private car hire services from Pune to Konkan Darshan, tailored for personalized itineraries and flexible travel schedules to suit your preferences."
    },
    {
      "name": "Pune to Konkan Darshan Taxi Charges",
      "description": "Transparent and competitive taxi charges for Pune to Konkan Darshan trips, with no hidden fees and multiple vehicle options to fit different budgets."
    },
    {
      "name": "Pune to Alibaug Beach Taxi",
      "description": "Reliable taxi services from Pune to Alibaug Beach, ensuring comfortable and timely travel for beach lovers and weekend getaways."
    },
    {
      "name": "Pune to Tarkarli Beach Cab fare",
      "description": "Affordable cab fares from Pune to Tarkarli Beach, offering budget-friendly travel with comfortable vehicles and professional drivers."
    },
    {
      "name": "Pune to Kashid Beach Cabs",
      "description": "Convenient cab services from Pune to Kashid Beach, perfect for day trips or extended beach vacations with flexible booking options."
    },
    {
      "name": "Pune to Malvan Beach Taxi Service",
      "description": "Specialized taxi services from Pune to Malvan Beach, ensuring safe and comfortable rides for travelers exploring the pristine beaches of the Konkan coast."
    },
    {
      "name": "Pune to Diveagar Beach Tempo Traveller",
      "description": "Spacious tempo traveller rentals from Pune to Diveagar Beach, ideal for group travel with ample room and comfort for all passengers."
    },
    {
      "name": "Pune to Ganpatipule Beach Cab Service",
      "description": "Dedicated cab service from Pune to Ganpatipule Beach, combining reliable transportation with scenic route options to enhance your beach trip experience."
    },
    {
      "name": "Pune to Ratnagiri cab service",
      "description": "Dependable cab services for Pune to Ratnagiri trips, offering a range of vehicles and packages suited for both leisure travelers and business visitors."
    },
    {
      "name": "Pune to Harihareshwar Beach Taxi Service",
      "description": "Comfortable and timely taxi services from Pune to Harihareshwar Beach, perfect for beach lovers seeking peaceful and scenic coastal retreats."
    }
  ],
  "tableData": [
    ["Pune to Konkan Darshan Taxi Services", "Pune to Konkan Darshan Cab Booking"],
    ["Pune to Konkan Darshan Car Rental", "Pune to Konkan Darshan Chauffeur-Driven Cabs"],
    ["Pune to Konkan Darshan One-Way Taxi", "Pune to Konkan Darshan Round Trip Cabs"],
    ["Pune to Konkan Darshan Luxury Taxi", "Pune to Konkan Darshan Travel Packages"],
    ["Pune to Konkan Darshan Private Car Hire", "Pune to Konkan Darshan Taxi Charges"],
    ["Pune to Alibaug Beach Taxi", "Pune to Tarkarli Beach Cab fare"],
    ["Pune to Kashid Beach Cabs", "Pune to Malvan Beach Taxi Service"],
    ["Pune to Diveagar Beach Tempo Traveller", "Pune to Ganpatipule Beach Cab Service"],
    ["Pune to Ratnagiri cab service", "Pune to Harihareshwar Beach Taxi Service"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Affordable Pune to Konkan Darshan Cabs for Scenic Travel",
        "WhyChoosedescription": "Platinum24 Cabs offers budget-friendly and comfortable cab services for your Pune to Konkan Darshan journey."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Vehicles for Group Tours",
        "WhyChoosedescription": "Our well-maintained cabs provide ample space and comfort, perfect for enjoying the Konkan Darshan route."
    },
    {
        "WhyChooseheading": "Clean and Sanitized Fleet for Your Safety",
        "WhyChoosedescription": "We prioritize hygiene with regular cleaning and sanitization of all vehicles before every trip."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Local Route Knowledge",
        "WhyChoosedescription": "Our skilled drivers are familiar with the Pune to Konkan Darshan route, ensuring a smooth and timely journey."
    },
    {
        "WhyChooseheading": "Flexible Booking Options for Customized Travel Plans",
        "WhyChoosedescription": "Choose from one-way, round-trip, or multi-day packages tailored to your Konkan Darshan itinerary."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Enjoy upfront, all-inclusive pricing covering fuel, tolls, and driver allowances for worry-free travel."
    },
    {
        "WhyChooseheading": "Ideal for Family Trips, Pilgrimages, and Group Excursions",
        "WhyChoosedescription": "Our Pune to Konkan Darshan cabs cater to diverse travel needs including leisure and religious tours."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
        "WhyChoosedescription": "Our dedicated support team is available round-the-clock to assist with bookings, changes, and special requests."
    }
]
















    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs provide cab services for Pune to Konkan Darshan tours?',
        answer: 'Yes, Platinum24 Cabs offers reliable and comfortable cab services for Pune to Konkan Darshan travel and sightseeing tours.',
    },
    {
        question: 'How can I book a Pune to Konkan Darshan cab with Platinum24 Cabs?',
        answer: 'You can easily book your Pune to Konkan Darshan cab through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Konkan Darshan trips?',
        answer: 'We offer a range of vehicles including sedans, SUVs, and premium cars to suit your travel preferences and group size.',
    },
    {
        question: 'Are the drivers experienced for long-distance tours like Pune to Konkan Darshan?',
        answer: 'Yes, all our drivers are professional, experienced, and knowledgeable about the Pune to Konkan Darshan routes and tourist spots.',
    },
    {
        question: 'Can I book a round trip cab for Pune to Konkan Darshan tours?',
        answer: 'Absolutely! We provide round-trip cab services with flexible scheduling to accommodate your sightseeing itinerary.',
    },
    {
        question: 'What is included in the fare for Pune to Konkan Darshan cab services?',
        answer: 'The fare includes vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for extra stops, sightseeing, or waiting time.',
    },
    {
        question: 'Can I customize pickup and drop-off locations for Pune to Konkan Darshan trips?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points based on your Konkan Darshan itinerary.',
    },
    {
        question: 'Are safety measures in place for Pune to Konkan Darshan cab rides?',
        answer: 'All vehicles are regularly sanitized, and our drivers follow strict safety protocols to ensure a safe and comfortable journey.',
    },
    {
        question: 'Is it possible to hire a cab for multiple days for Pune to Konkan Darshan tours?',
        answer: 'Yes, we offer hourly and multi-day rental packages tailored to your Konkan Darshan travel plans.',
    },
    {
        question: 'Does Platinum24 Cabs provide corporate or group tour services for Pune to Konkan Darshan?',
        answer: 'Yes, we offer customized corporate and group travel solutions including priority support and flexible billing for Konkan Darshan tours.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Rajesh Kulkarni',
        feedback: 'Our Konkan Darshan tour from Pune with Platinum24 Cabs was fantastic. The driver was knowledgeable and the vehicle was very comfortable.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Ananya Deshmukh',
        feedback: 'Platinum24 Cabs provided excellent service for our Pune to Konkan Darshan trip. Highly recommended for group tours and sightseeing!',
        rating: 5,
    },
];































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];








const puneToKonkanDarshanCabsSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Konkan Darshan Cabs",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-konkan-darshan-cabs.jpg",
  "description": "Explore the beautiful Konkan coast with Platinum24 Cabs. Book Pune to Konkan Darshan taxi services including luxury, chauffeur-driven, and private car hires for beaches like Alibaug, Tarkarli, Kashid, Malvan, and more.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "8200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2200",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-konkan-darshan-cabs"
  }
};






    return (
        <div>
<Helmet>
  <title>Pune to Konkan Darshan Cabs | Beach Taxi & Travel Packages | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Explore the beautiful Konkan coast with Platinum24 Cabs. Book Pune to Konkan Darshan taxi services including luxury, chauffeur-driven, and private car hires for beaches like Alibaug, Tarkarli, Kashid, Malvan, and more."
  />
  <meta
    name="keywords"
    content="Pune to Konkan Darshan Taxi Services, Pune to Konkan Darshan Cab Booking, Pune to Konkan Darshan Car Rental, Pune to Konkan Darshan Chauffeur-Driven Cabs, Pune to Konkan Darshan One-Way Taxi, Pune to Konkan Darshan Round Trip Cabs, Pune to Konkan Darshan Luxury Taxi, Pune to Konkan Darshan Travel Packages, Pune to Konkan Darshan Private Car Hire, Pune to Konkan Darshan Taxi Charges, Pune to Alibaug Beach Taxi, Pune to Tarkarli Beach Cab fare, Pune to Kashid Beach Cabs, Pune to Malvan Beach Taxi Service, Pune to Diveagar Beach Tempo Traveller, Pune to Ganpatipule Beach Cab Service, Pune to Ratnagiri cab service, Pune to Harihareshwar Beach Taxi Service"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToKonkanDarshanCabsSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/11.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetokonkandarshancabs;